export const PrimaryColor = "#001529";
export const SecondaryColor = "#002929";